import React from 'react';
import './styles.css';
export var ExternalLink = function (_a) {
    var title = _a.title, url = _a.url;
    return (React.createElement("a", { href: url, target: '_blank', className: 'link' }, title));
};
